/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { City } from "../City";
import { Country } from "../Country/Country";
import { CompanySettings } from "./CompanySettings";
import { companiesSellingTypes, companiesTypes, sellingTypes, types } from "./enums";
/**
 * Company model
 */

export class Company extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getType = (asLabel = false) => {
      return asLabel ? Company.companiesTypes[this.model.type || 'unknown'] || Company.companiesTypes['unknown'] : this.model.type;
    };

    this.getSellingType = (asLabel = false) => {
      return asLabel ? Company.companiesSellingTypes[this.model.sellingType || 'unknown'] || Company.companiesSellingTypes['unknown'] : this.model.sellingType;
    };

    this.getDescription = () => {
      return this.model.description;
    };

    this.getAddress = () => {
      return this.model.address;
    };

    this.getLogo = () => {
      return this.model.logo;
    };

    this.getSite = () => {
      return this.model.site;
    };

    this.getRating = () => {
      return Number(this.model.rating) || 5;
    };

    this.getPhone = () => {
      return this.model.phone;
    };

    this.getEmail = () => {
      return this.model.email;
    };

    this.getIsPartner = () => {
      return this.model.isPartner;
    };

    this.getIsOnlinePay = () => {
      return this.model.isOnlinePay;
    };

    this.getLatitude = () => {
      return Number(this.model.latitude);
    };

    this.getLongitude = () => {
      return Number(this.model.longitude);
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };

    this.getSettings = settings => {
      return this.getRelation('settings', CompanySettings, settings);
    };

    this.getCountry = country => {
      return this.getRelation('country', Country, country);
    };

    this.getCity = city => {
      return this.getRelation('city', City, city);
    };
  }

  /**
   * Create company
   *
   * @param {object} object
   *
   * @return {Company}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list company
   *
   * @param {object} objects
   *
   * @return {Array.<Company>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map companies
   *
   * @param {Array.<object>} objects
   * @param {function(Company): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get company id
   *
   * @return {number}
   */


}
Company.types = types;
Company.companiesTypes = companiesTypes;
Company.sellingTypes = sellingTypes;
Company.companiesSellingTypes = companiesSellingTypes;